<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>

    <hr />

    <div class="mb-3">
      <label>{{ 'Url or embed link' | translate }}</label>
      <input type="text" class="form-control" placeholder="" v-model="url" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['block'],
  data() {
    return {
      url: _.get(this.block, 'settings.url') || '',
    }
  },
  updated() {
    this.change()
  },
  methods: {
    change() {
      let previousSettings = _.get(this.block, 'settings')
      let newSettings = { ...this._data }

      if (previousSettings) {
        newSettings = {
          ...previousSettings,
          ...newSettings,
        }
      }
      newSettings = _(newSettings)
        .omitBy(_.isNil)
        .omitBy((value) => {
          return _.isEmpty(value) && !_.isInteger(value) && !_.isBoolean(value)
        })
        .value()

      if (_.isEmpty(newSettings)) {
        newSettings = null
      }

      this.block.settings = newSettings
    },
  },
}
</script>
<style></style>
